import React from 'react';
import { Pleb } from '../../../models/Pleb';
import { IconName } from '../../../components/Icon';
import Icon from '../../../components/Icon';
import { formatPhoneNumber } from '../../../utils/Utils';
import { useTheme } from '../../../hooks/useTheme';
import { CopyToClipboard } from '../../../components/CopyToClipboard';


interface ProfileDetailsProps {
  user: Pleb;
}

export const ProfileDetails: React.FC<ProfileDetailsProps> = ({ user }) => {
  const {isDarkMode} = useTheme();

  return (
    <div className="space-y-4">
      {user.profession && (
        <div className="flex items-center">
          <i className="text-[20px] material-icons">work</i>
          <span className="ml-2">{user.profession}</span>
        </div>
      )}

      {user.city && (
        <div className="flex items-center">
          <i className="text-[20px] material-icons">location_on</i>
          <span className="ml-2">{user.city}</span>
        </div>
      )}

      {user.interests && (
        <div className="flex items-center">
          <i className="text-[20px] material-icons">bookmark_border</i>
          <span className="ml-2">{user.interests}</span>
        </div>
      )}

      {user.website && (
        <div className="flex items-center">
          <i className="text-[20px] material-icons">link</i>
          <a 
            href={user.website.startsWith('http') ? user.website : `https://${user.website}`}
            target="_blank"
            rel="noopener noreferrer"
            className="ml-2 text-brand-orange hover:underline"
          >
            {user.website}
          </a>
        </div>
      )}

      {user.nostr && (
        <div className="flex items-center">
          <Icon name={IconName.NOSTR_LOGO} className="w-5 h-5" color={isDarkMode ? '#FFFFFF' : '#000000'} />
          <a 
            href={`https://primal.net/p/${user.nostr}`}
            target="_blank"
            rel="noopener noreferrer"
            className="ml-2 hover:underline break-all"
          >
            {user.nostr}
          </a>
        </div>
      )}

      {user.address && (
        <div className="flex items-center">
          <i className="text-[20px] material-icons">location_on</i>
          <button 
            onClick={() => {
              if (user.coordinates) {
                window.open(
                  `https://www.google.com/maps/search/?api=1&query=${user.coordinates.latitude},${user.coordinates.longitude}`,
                  '_blank'
                );
              }
            }}
            className="ml-2 hover:text-brand-orange text-left"
          >
            {user.address}
          </button>
        </div>
      )}

      {user.phoneNumber && (
        <div className="flex items-center">
          <i className="text-[20px] material-icons">phone</i>
          <a 
            href={`tel:${user.phoneNumber}`}
            className="ml-2 hover:text-brand-orange"
          >
            {formatPhoneNumber(user.phoneNumber)}
          </a>
        </div>
      )}
    </div>
  );
};
